import React from "react";
import { useT } from "../lib/i18n";

export default function WorkspaceLoading({ fullScreen = false, message }) {
  const t = useT();
  return (
    <div className={fullScreen ? "min-h-screen bg-[var(--bg)] px-5 py-16 text-[var(--text)]" : "py-4"} role="status" aria-live="polite" data-testid="workspace-loading">
      <div className="mx-auto w-full max-w-4xl space-y-5">
        <div>
          <p className="text-sm font-semibold">{message || t("workspace.loading")}</p>
          <p className="mt-1 text-xs text-[var(--text-2)]">{t("workspace.loading_detail")}</p>
        </div>
        <div aria-hidden="true" className="space-y-4 motion-safe:animate-pulse">
          <div className="h-8 w-2/3 rounded-sm bg-[var(--surface-elevated)]" />
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {[0, 1, 2].map((item) => <div key={item} className="h-24 rounded-sm border border-[var(--border)] bg-[var(--surface-elevated)]" />)}
          </div>
          <div className="h-40 rounded-sm border border-[var(--border)] bg-[var(--surface-elevated)]" />
        </div>
      </div>
    </div>
  );
}
